import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const DATA = Object.freeze({ can_process_card_via_stripe: false });

// SEE: https://getslick.atlassian.net/browse/GS-12543?focusedCommentId=17355
const beDisableCardCapability = actionBe('beDisableCardCapability', ({ AT, ATAG }) => endpoint(H.put, 'settings/remove/card/capability/stripe/salon/:salonId/', { AT, name: ATAG, data: DATA }));

export default beDisableCardCapability;
